import { QUESTIONNAIRE_PAGE_BOX_SX } from '../../../../common';

import type { SxProps, Theme } from '@mui/material';

export const MEDICAL_FORM_BOX_SX: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
  position: 'relative',
  textAlign: 'left',
  ...QUESTIONNAIRE_PAGE_BOX_SX,
};

export const MEDICAL_FORM_LOADING_OVERLAY_SX: SxProps<Theme> = {
  alignItems: 'center',
  bgcolor: 'rgba(255, 255, 255, 0.65)',
  display: 'flex',
  inset: 0,
  justifyContent: 'center',
  position: 'absolute',
  zIndex: 1,
};
